const en = {
  table: 'Table {label}',
  search: 'Search the menu',
  all: 'All',
  add: 'Add',
  soldOut: 'Sold out',
  required: 'Required',
  chooseUpTo: 'Choose up to {n}',
  chooseAtLeast: 'Choose at least {n}',
  chooseOne: 'Choose one',
  instructions: 'Cooking instructions (optional)',
  instructionsPlaceholder: 'e.g. no onion, less spicy',
  addToOrder: 'Add to order · {price}',
  cart: 'Your order',
  viewCart: 'View order · {count} item(s)',
  empty: 'Your order is empty. Add something from the menu.',
  subtotal: 'Subtotal',
  tax: 'Taxes & charges',
  total: 'Total',
  estimated: 'Estimated. The restaurant confirms the final amount.',
  confirmedByRestaurant: 'Priced by the restaurant',
  yourName: 'Your name',
  yourNameOptional: 'Your name (optional)',
  phoneOptional: 'Mobile number (optional)',
  yourDetails: 'Your details (optional)',
  skipDetails: 'Skip',
  addDetails: 'Add your name or mobile number',
  detailsWhy: 'Your mobile number lets the restaurant add loyalty points to this visit. It is shared only with this restaurant.',
  waUpdatesConsent: 'Send me updates about this order on WhatsApp',
  orderNote: 'Note for the restaurant (optional)',
  placeOrder: 'Send order to the restaurant',
  sending: 'Sending…',
  payAtCounter: 'You pay at the counter or after your meal.',
  restaurantOffline: 'The restaurant is not connected right now. Your order will wait until they come online, and it is not accepted until they confirm it.',
  backToMenu: 'Back to menu',
  orderMore: 'Order more',
  myOrders: 'My orders at this table',
  orderNumber: 'Order {n}',
  cancelOrder: 'Cancel order',
  cancelConfirm: 'Cancel this order?',
  payNow: 'Pay now · {price}',
  paid: 'Paid online',
  status_queued: 'Waiting for the restaurant to come online',
  status_awaiting_pos: 'Sent. Waiting for the restaurant',
  status_pending_acceptance: 'Waiting for the restaurant to accept',
  status_accepted: 'Accepted by the restaurant',
  status_preparing: 'Being prepared',
  status_ready: 'Ready',
  status_served: 'Served. Enjoy your meal!',
  status_completed: 'Completed',
  status_rejected: 'Not accepted',
  status_cancelled: 'Cancelled',
  status_expired: 'Not confirmed in time',
  notAcceptedYet: 'Not accepted yet. Please wait: staff will confirm shortly.',
  tableBill: 'Table bill so far',
  retry: 'Try again',
  invalidTable: 'This QR code is not valid. Please ask a member of staff.',
  invalidTitle: 'This table code is not active',
  invalidStep1: 'Ask a member of staff for the current QR code for your table.',
  invalidStep2: 'Scan it again with your phone camera. You can also order directly with the staff.',
  landingTitle: 'Scan the QR code on your table to order',
  landingLead: 'Each table at a participating restaurant has its own QR code. It opens that restaurant\'s menu for your table.',
  landingStep1: 'Open your phone camera and point it at the QR code on your table.',
  landingStep2: 'Choose your dishes and send the order to the restaurant.',
  landingStep3: 'Follow the status here while the restaurant accepts and prepares it.',
  landingWebsite: 'About KhataRasoi',
  landingHelp: 'Need help?',
  unavailableTitle: 'Ordering unavailable',
  kitchenStarted: 'The kitchen has started preparing this order, so it can no longer be cancelled here. Please speak to a member of staff if something is wrong.',
  acceptedNoCancel: 'The restaurant has accepted this order. Please speak to a member of staff to change it.',
  rateTitle: 'Rate your experience',
  rateStars: '{n} out of 5',
  rateComment: 'Anything to tell the restaurant? (optional)',
  rateSend: 'Send rating',
  rateThanks: 'Thank you for your rating!',
  allergens: 'Allergens: {list}',
  quantity: 'Quantity',
  decrease: 'Decrease quantity',
  increase: 'Increase quantity',
  remove: 'Remove',
  close: 'Close',
  language: 'Language',
};

type Messages = typeof en;

const hi: Partial<Messages> = {
  table: 'टेबल {label}',
  search: 'मेन्यू में खोजें',
  all: 'सभी',
  add: 'जोड़ें',
  soldOut: 'उपलब्ध नहीं',
  required: 'ज़रूरी',
  instructions: 'खाना बनाने के निर्देश (वैकल्पिक)',
  addToOrder: 'ऑर्डर में जोड़ें · {price}',
  cart: 'आपका ऑर्डर',
  viewCart: 'ऑर्डर देखें · {count} आइटम',
  subtotal: 'उप-योग',
  tax: 'कर और शुल्क',
  total: 'कुल',
  estimated: 'अनुमानित। अंतिम राशि रेस्टोरेंट तय करेगा।',
  placeOrder: 'रेस्टोरेंट को ऑर्डर भेजें',
  payAtCounter: 'भुगतान काउंटर पर या खाने के बाद करें।',
  status_pending_acceptance: 'रेस्टोरेंट की स्वीकृति का इंतज़ार',
  status_accepted: 'रेस्टोरेंट ने स्वीकार किया',
  status_preparing: 'तैयार हो रहा है',
  status_ready: 'तैयार',
  status_served: 'परोसा गया',
  status_rejected: 'स्वीकार नहीं हुआ',
  orderMore: 'और ऑर्डर करें',
  backToMenu: 'मेन्यू पर वापस',
  yourNameOptional: 'आपका नाम (वैकल्पिक)',
  phoneOptional: 'मोबाइल नंबर (वैकल्पिक)',
  yourDetails: 'आपका विवरण (वैकल्पिक)',
  skipDetails: 'छोड़ें',
  addDetails: 'अपना नाम या मोबाइल नंबर जोड़ें',
  detailsWhy: 'मोबाइल नंबर से रेस्टोरेंट इस विज़िट पर आपको लॉयल्टी पॉइंट दे सकता है। यह केवल इसी रेस्टोरेंट के साथ साझा होता है।',
  waUpdatesConsent: 'इस ऑर्डर की जानकारी मुझे WhatsApp पर भेजें',
  invalidTable: 'यह QR कोड मान्य नहीं है। कृपया स्टाफ़ से संपर्क करें।',
  invalidTitle: 'यह टेबल कोड सक्रिय नहीं है',
  invalidStep1: 'अपनी टेबल का मौजूदा QR कोड स्टाफ़ से माँगें।',
  invalidStep2: 'फ़ोन कैमरे से उसे फिर स्कैन करें। आप स्टाफ़ से सीधे भी ऑर्डर कर सकते हैं।',
  landingTitle: 'ऑर्डर करने के लिए अपनी टेबल का QR कोड स्कैन करें',
  landingLead: 'हर टेबल का अपना QR कोड होता है। वह उस रेस्टोरेंट का मेन्यू आपकी टेबल के लिए खोलता है।',
  landingStep1: 'फ़ोन का कैमरा खोलें और टेबल पर लगे QR कोड की ओर रखें।',
  landingStep2: 'अपने व्यंजन चुनें और ऑर्डर रेस्टोरेंट को भेजें।',
  landingStep3: 'रेस्टोरेंट के स्वीकार करने और तैयार करने की स्थिति यहीं देखें।',
  landingWebsite: 'KhataRasoi के बारे में',
  landingHelp: 'मदद चाहिए?',
  kitchenStarted: 'रसोई में यह ऑर्डर बनना शुरू हो गया है, इसलिए अब इसे यहाँ से रद्द नहीं किया जा सकता। कोई समस्या हो तो स्टाफ़ से बात करें।',
  acceptedNoCancel: 'रेस्टोरेंट ने यह ऑर्डर स्वीकार कर लिया है। बदलाव के लिए स्टाफ़ से बात करें।',
  rateTitle: 'अपना अनुभव रेट करें',
  rateStars: '5 में से {n}',
  rateComment: 'रेस्टोरेंट से कुछ कहना है? (वैकल्पिक)',
  rateSend: 'रेटिंग भेजें',
  rateThanks: 'रेटिंग के लिए धन्यवाद!',
};

const es: Partial<Messages> = {
  table: 'Mesa {label}',
  search: 'Buscar en el menú',
  all: 'Todo',
  add: 'Añadir',
  soldOut: 'Agotado',
  required: 'Obligatorio',
  instructions: 'Instrucciones de cocina (opcional)',
  addToOrder: 'Añadir al pedido · {price}',
  cart: 'Tu pedido',
  viewCart: 'Ver pedido · {count} artículo(s)',
  subtotal: 'Subtotal',
  tax: 'Impuestos y cargos',
  total: 'Total',
  estimated: 'Estimado. El restaurante confirma el importe final.',
  placeOrder: 'Enviar pedido al restaurante',
  payAtCounter: 'Pagas en caja o al terminar.',
  status_pending_acceptance: 'Esperando que el restaurante acepte',
  status_accepted: 'Aceptado por el restaurante',
  status_preparing: 'En preparación',
  status_ready: 'Listo',
  status_served: 'Servido',
  status_rejected: 'No aceptado',
  orderMore: 'Pedir más',
  backToMenu: 'Volver al menú',
  yourNameOptional: 'Tu nombre (opcional)',
  phoneOptional: 'Número de móvil (opcional)',
  yourDetails: 'Tus datos (opcional)',
  skipDetails: 'Omitir',
  addDetails: 'Añade tu nombre o móvil',
  detailsWhy: 'Tu móvil permite al restaurante sumar puntos de fidelidad a esta visita. Solo se comparte con este restaurante.',
  waUpdatesConsent: 'Envíame avisos de este pedido por WhatsApp',
  invalidTable: 'Este código QR no es válido. Pide ayuda al personal.',
  invalidTitle: 'Este código de mesa no está activo',
  invalidStep1: 'Pide al personal el código QR actual de tu mesa.',
  invalidStep2: 'Escanéalo de nuevo con la cámara del teléfono. También puedes pedir directamente al personal.',
  landingTitle: 'Escanea el código QR de tu mesa para pedir',
  landingLead: 'Cada mesa tiene su propio código QR, que abre el menú del restaurante para tu mesa.',
  landingStep1: 'Abre la cámara del teléfono y apunta al código QR de tu mesa.',
  landingStep2: 'Elige tus platos y envía el pedido al restaurante.',
  landingStep3: 'Sigue aquí el estado mientras el restaurante lo acepta y prepara.',
  landingWebsite: 'Acerca de KhataRasoi',
  landingHelp: '¿Necesitas ayuda?',
  kitchenStarted: 'La cocina ya empezó a preparar este pedido, así que ya no se puede cancelar aquí. Habla con el personal si hay algún problema.',
  acceptedNoCancel: 'El restaurante aceptó este pedido. Habla con el personal para cambiarlo.',
  rateTitle: 'Valora tu experiencia',
  rateStars: '{n} de 5',
  rateComment: '¿Algo que decir al restaurante? (opcional)',
  rateSend: 'Enviar valoración',
  rateThanks: '¡Gracias por tu valoración!',
};

export const LANGUAGES = { en: 'English', hi: 'हिन्दी', es: 'Español' } as const;
export type Lang = keyof typeof LANGUAGES;
const catalogs: Record<Lang, Partial<Messages>> = { en, hi, es };

export function detectLang(): Lang {
  try {
    const saved = localStorage.getItem('qr-lang') as Lang | null;
    if (saved && saved in catalogs) return saved;
  } catch {
    /* ignore */
  }
  const nav = (navigator.language || 'en').slice(0, 2) as Lang;
  return nav in catalogs ? nav : 'en';
}

export type T = (key: keyof Messages, vars?: Record<string, string | number>) => string;

export function translator(lang: Lang): T {
  return (key, vars) => {
    let text = (catalogs[lang][key] ?? en[key]) as string;
    for (const [k, v] of Object.entries(vars ?? {})) text = text.replace(`{${k}}`, String(v));
    return text;
  };
}
